<template>
  <ActivityFrame
    :type="isInfoDisplayed"
    :endpage="true"
    :is-award="item.isGetAward"
    :award="item.activityItemName"
  >
    <template v-slot:content>
      <ActivityInfo v-show="isInfoDisplayed" />
      <div
        class="text-white d-flex justify-content-center align-items-center my-3 mx-auto"
        style="position:relative; width:300px"
      >
        <img
          v-show="!isInfoDisplayed"
          :src="item.activityItemImage"
        >
      </div>
      <p
        v-show="!isInfoDisplayed && item.isGetAward"
        class="my-2"
        :style="`color: rgba(${EventData.transparentMask === '255,255,255' ? '0,0,0' : '255,255,255'}`"
      >
        {{ $t('global.personal-notify-info') }}
        <a
          href="#"
          @click="goToMemberCenterWithCode"
        ><u>{{ $t('global.personal-notify') }}</u></a>
        {{ $t('global.confirm') }}
      </p>
      <!-- 行動呼籲 start -->
      <CTAButton
        v-show="!isInfoDisplayed"
        :info="entertainmentInfo"
      />
      <!-- 行動呼籲 end -->
      <div
        class="my-2 d-flex flex-column"
        @click="isInfoDisplayed = !isInfoDisplayed"
      >
        <span
          class="material-icons"
          :style="`color: rgba(${EventData.transparentMask === '255,255,255' ? '0,0,0' : '255,255,255'}, 1.0);`"
        >
          {{ isInfoDisplayed ? "keyboard_arrow_down" : "keyboard_arrow_up" }}
        </span>
        <h6
          :class="[isInfoDisplayed ? 'd-none' : 'd-flex']"
          class="justify-content-center"
          :style="`color: rgba(${EventData.transparentMask === '255,255,255' ? '0,0,0' : '255,255,255'}, 1.0);`"
        >
          <span>{{ $t("activity.activity-rules") }}</span>
        </h6>
      </div>
    </template>
  </ActivityFrame>
</template>

<script>
import ActivityFrame from '@/components/activity/ActivityFrame.vue';
import ActivityInfo from '@/components/activity/ActivityInfo.vue';
import CTAButton from '@/components/activity/CTAButton.vue';
import store from '@/store/index';
import i18n from '@/locales/i18n';
import { callbackRedirect } from '@/route/activity';

export default {
  components: {
    ActivityFrame,
    CTAButton,
    ActivityInfo,
  },
  data() {
    return {
      // 活動資料
      activity: { scratchOffInfo: {}, slotInfo: {}, rouletteInfo: {} },
      // 商品資料
      item: {},
      // 是否顯示活動辦法
      isInfoDisplayed: false,
      EventData: {
        titleColor: '',
        transparentMask: '',
      },
      canShare: true,
    };
  },
  beforeRouteEnter(to, from, next) {
    if (!to.params.companyId || !to.params.memberSourceId || !to.params.activityId || !to.params.eventId) {
      next({
        name: 'Error',
        params: { content: i18n.t('error.url-invalid') },
      });
    } else {
      store.commit('set', { name: 'companyId', value: to.params.companyId });
      store.commit('set', { name: 'memberSourceId', value: to.params.memberSourceId });
      store.commit('set', { name: 'activityId', value: to.params.activityId });
      // 取得活動資料
      store.dispatch('getActivity').then((activity) => {
        if (!activity || activity.status !== 'submitted') {
        // 前往活動錯誤頁函數
          next({
            name: 'Error',
            params: { content: i18n.t('error.activity-not-found') },
          });
        } else {
        // 回到活動首頁
          const goToFrontPage = () => {
            next({
              name: activity.isShareFullURL ? 'FrontPage' : 'FrontPageFake',
              params: {
                eventId: to.params.eventId,
                companyId: to.params.companyId,
                memberSourceId: to.params.memberSourceId,
                activityId: to.params.activityId,
              },
            });
          };
          // 沒有會員Id或token
          if (!store.state.memberId || !store.state.accessToken) {
            goToFrontPage();
            return;
          }
          next();
        }
      });
    }
  },
  beforeRouteLeave(to, from, next) {
    // 上一步的判斷，如為callback，前往首頁
    callbackRedirect(to, from, next, this.canShare);
  },
  computed: {
    // 娛樂活動資料(刮刮樂...)
    entertainmentInfo() {
      const vm = this;
      switch (vm.activity.categoryID) {
        // 刮刮樂
        case 'Scratchoff':
          return vm.activity.scratchOffInfo;
        // 拉霸
        case 'Slot':
          return vm.activity.slotInfo;
        // 輪盤
        case 'Roulette':
          return vm.activity.rouletteInfo;
        default:
          return {};
      }
    },
  },
  created() {
    const vm = this;
    // 取得活動資料
    vm.$store.dispatch('getActivity').then(
      (activity) => {
        vm.activity = activity;
        vm.canShare = activity ? activity.isShareFullURL : true;
        switch (activity.categoryID) {
          case 'Scratchoff':
            vm.EventData.titleColor = activity.scratchOffInfo.titleColor;
            vm.EventData.transparentMask = activity.scratchOffInfo.transparentMask;
            break;
          case 'Slot':
            vm.EventData.titleColor = activity.slotInfo.titleColor;
            vm.EventData.transparentMask = activity.slotInfo.transparentMask;
            break;
          case 'Roulette':
            vm.EventData.titleColor = activity.rouletteInfo.titleColor;
            vm.EventData.transparentMask = activity.rouletteInfo.transparentMask;
            break;
          default:
            break;
        }
        // 取得活動結果資料
        vm.$store.dispatch('getActivityResult', activity.no).then((item) => {
          // 取得第一筆活動結果資料
          [vm.item] = item;
        });
      },
    );
  },
  methods: {
    goToMemberCenterWithCode() {
      const code = sessionStorage.getItem('code');
      sessionStorage.removeItem('code');
      sessionStorage.removeItem('memberId');
      sessionStorage.removeItem('memberAcntNo');

      const params = {
        companyid: this.$store.state.companyId,
        membersourceid: this.$store.state.memberSourceId,
        code,
      };
      const queryString = new URLSearchParams(params).toString();
      const href = `${window.location.origin}/rewards/membercenter/notification?${queryString}`;

      window.location.href = href;
    },
  },
};
</script>
